export function isoToDMY(input) {
  if (!input) return '';

  let date;
  if (typeof input === 'string') {
    const m = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const [_, y, mo, d] = m;
      date = new Date(Date.UTC(Number(y), Number(mo) - 1, Number(d)));
    } else {
      date = new Date(input);
    }
  } else {
    date = input;
  }

  if (Number.isNaN(date?.getTime?.())) return '';

  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = date.getUTCFullYear();

  return `${dd}/${mm}/${yyyy}`;
}
